import { render, staticRenderFns } from "./ClientJbbfCreateUpdateCard.vue?vue&type=template&id=030be382&"
import script from "./ClientJbbfCreateUpdateCard.vue?vue&type=script&lang=js&"
export * from "./ClientJbbfCreateUpdateCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports